import React, { createContext, useContext, useState, useEffect } from 'react';

const UserDataContext = createContext();

export const UserDataProvider = ({ children }) => {
  // Cargar datos del usuario desde localStorage
  const [userData, setUserData] = useState(() => {
    const saved = localStorage.getItem('userData');
    return saved ? JSON.parse(saved) : {
      email: '',
      phone: '',
      firstName: '',
      lastName: ''
    };
  });

  // Cargar códigos de acceso desde localStorage
  const [projectAccessCodes, setProjectAccessCodes] = useState(() => {
    const saved = localStorage.getItem('projectAccessCodes');
    return saved ? JSON.parse(saved) : {};
  });

  // Guardar userData en localStorage cuando cambie
  useEffect(() => {
    if (userData.email) {
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  }, [userData]);

  // Guardar códigos en localStorage cuando cambien
  useEffect(() => {
    localStorage.setItem('projectAccessCodes', JSON.stringify(projectAccessCodes));
  }, [projectAccessCodes]);

  // Actualizar datos del usuario
  const updateUserData = (data) => {
    setUserData(prev => ({ ...prev, ...data }));
  };

  // Guardar código de acceso a un proyecto
  const saveProjectAccessCode = (projectId, accessCode) => {
    setProjectAccessCodes(prev => ({
      ...prev,
      [projectId]: accessCode
    }));
  };

  // Obtener código de acceso a un proyecto
  const getProjectAccessCode = (projectId) => {
    return projectAccessCodes[projectId] || null;
  };

  // Verificar si tiene acceso a un proyecto
  const hasProjectAccess = (projectId) => {
    return !!projectAccessCodes[projectId];
  };

  // Limpiar todos los datos
  const clearUserData = () => {
    setUserData({ email: '', phone: '', firstName: '', lastName: '' });
    setProjectAccessCodes({});
    localStorage.removeItem('userData');
    localStorage.removeItem('projectAccessCodes');
  };

  const value = {
    userData,
    updateUserData,
    projectAccessCodes,
    saveProjectAccessCode,
    getProjectAccessCode,
    hasProjectAccess,
    clearUserData
  };

  return (
    <UserDataContext.Provider value={value}>
      {children}
    </UserDataContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const useUserData = () => {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error('useUserData debe usarse dentro de UserDataProvider');
  }
  return context;
};
